import LessonProgressDashboardStats from '@/models/LessonProgressDashboardStats';
import percentage from '@/utils/statistics/percentage';

export type UnitProgress = {
  completed: number;
  total: number;
  percentage: number;
};

export const toUnitProgress = (
  lessonProgresses: LessonProgressDashboardStats[],
  unitId?: number,
): UnitProgress => {
  const unitLessonProgresses = unitId
    ? lessonProgresses.filter(({ lesson }) => lesson.lessonBlock?.id === unitId)
    : lessonProgresses;

  const completed = unitLessonProgresses.filter(
    ({ lesson }) => lesson.hasDone === true,
  ).length;
  const total = unitLessonProgresses.length;

  return {
    completed,
    total,
    percentage: total ? percentage(completed / total, 0) : 0,
  };
};
